(function () {
  "use strict";
  // A section can include this asset more than once in the theme editor.
  if (window.__terraMobileLayout) return;
  window.__terraMobileLayout = true;
  var mobileQuery = window.matchMedia("(max-width: 900px)");
  var touchQuery = window.matchMedia("(hover: none) and (pointer: coarse)");
  var width = 0;
  var height = 0;
  var reservedHeaderHeight = 0;
  var resizeTimer;
  var probe = document.createElement("div");
  probe.style.cssText = "position:absolute;top:0;left:0;width:0;height:100svh;visibility:hidden;pointer-events:none";

  function updateAll() {
    var header = document.querySelector("[data-site-header], [data-terra-header], .terra-header, header");
    var headerHeight = header ? Math.ceil(header.getBoundingClientRect().height) : 150;
    // Reserve the expanded header: its scroll-driven shrink must not move the stage.
    reservedHeaderHeight = Math.max(reservedHeaderHeight, headerHeight);
    document.querySelectorAll("[data-terra-world]").forEach(function (root) {
      root.classList.remove("is-mobile-intro-active", "is-mobile-chapter-active");
      root.classList.toggle("is-mobile-node-labels-visible", mobileQuery.matches);
      if (!mobileQuery.matches) {
        root.style.removeProperty("--terra-mobile-header-height");
        root.style.removeProperty("--terra-stable-viewport");
        return;
      }
      root.style.setProperty("--terra-mobile-header-height", reservedHeaderHeight + "px");
      root.style.setProperty("--terra-stable-viewport", height + "px");
      root.dispatchEvent(new CustomEvent("terra:world-layout"));
    });
  }

  function measure(force) {
    var nextWidth = document.documentElement.clientWidth;
    var nextHeight = window.innerHeight;
    // Preserve the small viewport across touch browser-chrome height changes.
    if (!force && nextWidth === width && touchQuery.matches && Math.abs(nextHeight - height) < height * .25) return;
    if (force || nextWidth !== width) reservedHeaderHeight = 0;
    width = nextWidth;
    height = probe.offsetHeight || nextHeight;
    updateAll();
  }
  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () { measure(false); }, 180);
  }
  function onOrientation() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () { measure(true); }, 240);
  }
  function mount() {
    document.body.appendChild(probe);
    measure(true);
    var header = document.querySelector("[data-site-header], [data-terra-header], .terra-header, header");
    if (header && "ResizeObserver" in window) {
      var previousHeight = Math.ceil(header.getBoundingClientRect().height);
      var observer = new ResizeObserver(function () {
        var nextHeight = Math.ceil(header.getBoundingClientRect().height);
        if (nextHeight === previousHeight) return;
        previousHeight = nextHeight;
        if (nextHeight > reservedHeaderHeight) updateAll();
      });
      observer.observe(header);
    }
  }
  window.addEventListener("resize", onResize, { passive: true });
  window.addEventListener("orientationchange", onOrientation, { passive: true });
  document.addEventListener("shopify:section:load", updateAll);
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", mount, { once: true });
  else mount();
})();
